import React from 'react';

export default class Description extends React.Component {
  render() {
    return (
      	<section className="description-container">
          <header>
            <h1 className="description__title">{this.props.title}</h1>
          </header>
      		<article>
      			<p className="description__story">{this.props.description}</p>
      		</article>
      	</section>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Description.js